<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm10 md6 lg5 xl4>
        <v-card flat>
<!--          <v-toolbar dark flat color="primary">-->
<!--            <v-toolbar-title-->
<!--                style="background-image: url('/static/logo.png');background-size: auto 30px;padding-left: 130px;">-->
<!--              科研管理信息系统-->
<!--            </v-toolbar-title>-->
<!--            <v-spacer></v-spacer>-->
<!--            <v-tooltip right>-->
<!--              <v-btn-->
<!--                  icon-->
<!--                  large-->
<!--                  href="#"-->
<!--                  target="_blank"-->
<!--                  slot="activator"-->
<!--              >-->
<!--                <v-icon large>help_outline</v-icon>-->
<!--              </v-btn>-->
<!--              <span>需要帮助？</span>-->
<!--            </v-tooltip>-->
<!--          </v-toolbar>-->
          <v-progress-linear class="my-0" :indeterminate="true" v-if="loginLoading" :active="loginLoading" height="2"
                             color="orange"/>
          <v-alert
              type="error"
              :value="showMessage"
              style="margin: 0;border-color: transparent !important;"
          >
            {{ message }}
          </v-alert>
          <v-tabs>
            <v-tab @click.native.stop="step=1">用户名密码登录</v-tab>
            <v-tab @click.native.stop="step=3">手机号登录</v-tab>
          </v-tabs>
          <v-stepper v-model="step" class="elevation-0">
            <v-stepper-items>
              <v-stepper-content step="1" class="pa-0">
                <v-card-text>
                  <v-form v-model="loginFormValid" ref="loginFormRef" lazy-validation>
                    <v-text-field
                        :disabled="loginLoading"
                        prepend-icon="person"
                        v-model="userDeptRole.username"
                        name="username"
                        label="用户名"
                        :rules="rules.username"
                        hint="用户名为工号"
                        id="username"
                        type="text"/>

                    <v-text-field
                        :disabled="loginLoading"
                        prepend-icon="lock"
                        v-model="userDeptRole.password"
                        name="password"
                        label="密码"
                        :rules="rules.password"
                        id="password"
                        type="password"
                        @keyup.enter="onNormalLogin"
                    />
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <!--                  <v-btn color="primary" flat href="./reset_passwd">忘记密码？</v-btn>-->
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click.native.stop="onNormalLogin" :disabled="loginLoading">
                    {{ loginLoading ? '正在登录' : '登录' }}
                  </v-btn>
                </v-card-actions>
              </v-stepper-content>
              <v-stepper-content step="2" class="pa-0">
                <v-card-text>
                  <v-form>
                    <v-subheader>请选择部门和角色</v-subheader>
                    <v-radio-group
                        v-model="userDeptRoleSel"
                        @change="onDeptRoleChange"
                        class="pt-0 pl-3"
                    >
                      <v-radio
                          v-for="udr in userDeptRoleItems"
                          :key="`${udr.deptId}-${udr.roleId}`"
                          :label="`${udr.deptName}[${udr.roleName}]`"
                          :value="udr"
                      />
                    </v-radio-group>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click.native.stop="doLogin" :disabled="loginLoading">
                    {{ loginLoading ? '正在登录' : '确定' }}
                  </v-btn>
                </v-card-actions>
              </v-stepper-content>

              <v-stepper-content step="3" class="pa-0">
                <v-card-text>
                  <v-form v-model="smsFormValid" ref="smsFormRef" lazy-validation>
                    <v-text-field
                        :disabled="loginLoading"
                        prepend-icon="phone_iphone"
                        v-model="sms.phoneNumber"
                        name="phoneNumber"
                        label="手机号"
                        :rules="rules.phoneNumber"
                        id="phone_number"
                        type="text"/>
                    <v-text-field
                        :disabled="loginLoading"
                        prepend-icon="vpn_key"
                        v-model="sms.validCode"
                        name="validCode"
                        label="验证码"
                        :rules="rules.validCode"
                        id="valid_code"
                        @keyup.enter="onSmsLogin"
                    >
                      <template v-slot:append>
                        <v-btn depressed small @click.native.stop="onSendSmsValidCode"
                               :disabled="disableSendSms">{{ sendSmsMsg }}
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click.native.stop="onSmsLogin">登录</v-btn>
                </v-card-actions>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
const loginURI = '/api/login';
const smsValidCodeURI = 'api/sms/valid_code'
const smsLoginURI = 'api/sms/token'

import md5 from 'md5'

const phoneNumberRegex = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/ig

export default {
  data: () => ({
    loginLoading: false,
    afterLogin: null,

    sms: {
      phoneNumber: '',
      validCode: '',
    },

    userDeptRole: {
      userId: '',
      name: '',
      username: '',
      password: '',
      passwdMd5: '',
      deptId: '',
      deptName: '',
      roleId: '',
      roleName: '',
      roleRoute: null
    },

    timer: '',
    counter: 120,

    loginFormValid: false,
    smsFormValid: false,

    /**
     * 验证规则
     */
    rules: {
      username: [
        v => !!v || '请填写用户名'
      ],
      password: [
        v => !!v || '请填写密码',
      ],

      phoneNumber: [
        v => !!v || '请填写手机号',
        v => (v && /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/ig.test(v)) || '手机号码格式不正确。'
      ],
      validCode: [
        v => !!v || '请填写验证码',
        v => (v && /^\d{4}$/ig.test(v)) || '验证码格式不正确'
      ]
    },

    userDeptRoleItems: [],
    userDeptRoleSel: {},

    sendSmsMsg: '发送验证码',

    step: 1,
    message: '',
  }),

  // 路由进入前，组件就未完成渲染，不可以使用 this
  beforeRouteEnter(to, from, next) {
    next(
        vm => {
          vm.afterLogin = to.query.url || null;
          vm.userDeptRole = {
            userId: '',
            name: '',
            username: '',
            password: '',
            passwdMd5: '',
            deptId: '',
            deptName: '',
            roleId: '',
            roleName: '',
            roleRoute: null
          };
          vm.userDeptRoleItems = [];
          vm.userDeptRoleSel = {};

          vm.step = 1;
          vm.message = '';
        });
  },

  // 路由改变前，组件就已经渲染完成，可以使用 this
  beforeRouteUpdate(to, from, next) {
    this.userDeptRole = {
      userId: '',
      name: '',
      username: '',
      passwdMd5: '',
      password: '',
      deptId: '',
      deptName: '',
      roleId: '',
      roleName: '',
      roleRoute: null
    };
    this.userDeptRoleItems = [];
    this.userDeptRoleSel = {};
    this.step = 1;
    this.message = '';

    next();
  },

  computed: {
    showMessage() {
      return this.message && this.message.length > 0;
    },

    disableSendSms() {
      let validPhone = phoneNumberRegex.test(this.sms.phoneNumber)
      let waitTimeout = this.counter < 120
      return !validPhone || waitTimeout;
    }
  },
  methods: {
    onNormalLogin() {
      this.message = "";

      if (!this.$refs.loginFormRef.validate()) {
        return;
      }

      window.loginType = 'normal'
      this.userDeptRole.passwdMd5 = md5(this.userDeptRole.password);
      this.onLogin();
    },

    onLogin() {
      const vm = this;
      if (vm.loginLoading === true) return;

      vm.loginLoading = true;
      window.console.log("login");

      const username = this.userDeptRole.username;
      const passwdMd5 = this.userDeptRole.passwdMd5;

      const token = window.xutil.token('GET', loginURI, 0, username, passwdMd5, '', '');

      vm.message = '';
      // !!!Important, invalid last session
      this.$store.commit("logout");
      this.axios.get(loginURI, {headers: {'X-AUTH-TOKEN': token}})
          .then(
              rsp => {
                if (!Array.isArray(rsp.data)) {
                  vm.message = rsp.data.message;
                  vm.loginLoading = false;
                  return;
                }

                vm.userDeptRoleItems = rsp.data.map(
                    udr => {
                      delete udr.password;
                      return udr;
                    }
                );

                // 默认先选中第一个角色
                vm.userDeptRoleSel = vm.userDeptRoleItems[0];
                Object.assign(vm.userDeptRole, vm.userDeptRoleSel);

                // 该用户只有一个部门和角色
                if (vm.userDeptRoleItems.length === 1) {
                  this.doLogin();
                } else {
                  vm.loginLoading = false;
                  vm.step = 2;
                }
              }
          )
          .catch(() => {
            vm.loginLoading = false;
          });
    },

    // 选择用户的部门和角色
    onDeptRoleChange(v) {
      //console.log(v);
      Object.assign(this.userDeptRole, v);
    },

    doLogin() {
      const vm = this;
      vm.loginLoading = true;

      this.$store.commit("login",
          Object.assign({}, this.userDeptRole,
              {deptRoles: this.userDeptRoleItems},
              {"password": this.userDeptRole.passwdMd5, "passwordRaw": this.userDeptRole.password}));

      const path = this.afterLogin || "/";

      this.$router.push(
          {path: path},
          () => vm.loginLoading = false, // onComplete
          () => vm.loginLoading = false, // onAbort
      );
    },

    onSmsLogin() {
      const vm = this;
      vm.message = "";
      if (!this.$refs.smsFormRef.validate()) {
        return;
      }

      if (this.timer) {
        clearInterval(this.timer)
      }

      this.axios.get(`${smsLoginURI}/${this.sms.phoneNumber}/${this.sms.validCode}`)
          .then(
              rsp => {
                window.console.log(rsp)
                if (rsp.data.username && rsp.data.token) {
                  this.userDeptRole.username = rsp.data.username;
                  this.userDeptRole.passwdMd5 = rsp.data.token;
                  window.loginType = 'sms';
                  this.onLogin();
                } else {
                  vm.message = rsp.data.message || '登录错误';
                  vm.loginLoading = false;
                }

              })
          .catch(() => {
            vm.loginLoading = false;
          });

    },

    onSendSmsValidCode() {
      const vm = this;
      vm.message = "";

      // 限制发送短信频率
      this.counter = 120;
      this.timer = setInterval(this.counting, 1000);

      this.sendSmsMsg = '正在发送...'
      // 调用发送接口
      this.axios.get(`${smsValidCodeURI}/${this.sms.phoneNumber}`).then(rsp => {
        window.console.log(rsp)
        if (rsp.data && rsp.data.success === "true") {
          this.sendSmsMsg = `${this.counter}秒后可重发`;
        } else {
          vm.message = rsp.data.message || '短信发送错误';
        }
      }).catch(() => {
        vm.loginLoading = false;
      });
    },

    // 短信重发计时
    counting() {
      this.counter = this.counter - 1;
      if (this.counter <= 0) {
        clearInterval(this.timer);
        this.sendSmsMsg = '发送验证码';
        this.counter = 120;
        this.timer = '';
      }
    }
  }
}
</script>
<style scoped>
div.stepper__content {
  padding: 0;
}
</style>
